import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { countries, devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Text input for User ID
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label for User ID
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Hide if permission is not granted
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            minWidth: 200,
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Hide if permission is not granted or country report is enabled
                            css: 'prm-filterByCountry',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'radio', // Radio buttons for selecting type
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Label for type selection
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen == 'small' ? 0 : 100, // Conditional height based on screen size
                            value: 0, // Default value
                            options: [
                                { id: 0, value: _('Detallado') }, // Detailed option
                                { id: 1, value: _('Totales') }, // Total option
                            ],
                        },
                        { id: 'grav2', gravity: 1, minWidth: 200 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Adding left section to upper section
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 }, // Gravity for layout adjustment
                        {
                            view: 'button', // Button for adjusting points
                            value: _('Ajustar Puntos'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('pointsAdjustmentsAdd', 'Add'), // Hide if permission is not granted
                            css: 'prm-pointsAdjustmentsAdd',
                            click: () => {
                                webix
                                    .ui({
                                        view: 'window', // Popup window for point adjustments
                                        id: 'SubAdjustments',
                                        height: 550,
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Ajustar Puntos'), // Label for popup
                                                    align: 'center',
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close popup
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'subform', // Form for point adjustment
                                            elements: [
                                                {
                                                    view: 'text',
                                                    label: _('Usuario Id:'), // Label for User ID
                                                    name: 'IdUser',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    type: 'number',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'combo', // Dropdown for type selection
                                                    label: _('Tipo:'),
                                                    name: 'Type',
                                                    id: 'Type',
                                                    required: true, // Required field
                                                    labelPosition: 'top',
                                                    options: [
                                                        {
                                                            id: '20',
                                                            value: _(
                                                                'Apuesta deportiva', // Sports bet option
                                                            ),
                                                        },
                                                        {
                                                            id: '30',
                                                            value: _(
                                                                'Apuesta de casino', // Casino bet option
                                                            ),
                                                        },
                                                    ],
                                                    labelWidth: 150,
                                                },
                                                {
                                                    view: 'text',
                                                    label: _('Id Apuesta:'), // Label for bet ID
                                                    name: 'Identifier',
                                                    id: 'Identifier',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button', // Cancel button
                                                            value: _('Cancelar'),
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close popup
                                                                $$('subform').setValues(
                                                                    $$('subform').getCleanValues(), // Reset form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button
                                                            type: 'form',
                                                            value: _('Guardar'),
                                                            click: function ($e) {
                                                                let values = $$('subform').getValues(); // Get form values
                                                                if (
                                                                    $$('subform').validate() // Validate form
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Report/loyaltyPoints', // API endpoint
                                                                            {
                                                                                ...values,
                                                                                ForUserTest: false, // Additional data
                                                                            },
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var json = JSON.parse(
                                                                                        text, // Parse response
                                                                                    );
                                                                                    if (
                                                                                        json.HasError // Check for errors
                                                                                    ) {
                                                                                        webix.message({
                                                                                            title: _('¡Error!'),
                                                                                            type: 'alert-error',
                                                                                            text: json.AlertMessage, // Display error message
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Puntos Ajustado', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('subform').setValues(
                                                                        $$('subform').getCleanValues(), // Reset form values
                                                                    );
                                                                    this.getTopParentView().hide(); // Close popup
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Completa los campos...', // Validation error message
                                                                        ),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show popup
                            },
                        },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form
                                $$('Type').setValue(0); // Reset type selection
                                $$('NegativeBalances').setValue(1); // Reset negative balances
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter', // Enter key shortcut
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter data
                                this.app.callEvent(
                                    'balanceAdjustments:filter',
                                    [filterdata], // Trigger filter event
                                );
                                $$('b5').collapse(); // Collapse filter section
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button for adjusting points
                            value: _('Ajustar Puntos'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('pointsAdjustmentsAdd', 'Add'), // Hide if permission is not granted
                            css: 'prm-pointsAdjustmentsAdd',
                            click: () => {
                                webix
                                    .ui({
                                        view: 'window', // Popup window for point adjustments
                                        id: 'SubAdjustments',
                                        height: 550,
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Ajustar Puntos'), // Label for popup
                                                    align: 'center',
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close popup
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'subform', // Form for point adjustment
                                            elements: [
                                                {
                                                    view: 'text',
                                                    label: _('Usuario Id:'), // Label for User ID
                                                    name: 'IdUser',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    type: 'number',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'combo', // Dropdown for type selection
                                                    label: _('Tipo:'),
                                                    name: 'Type',
                                                    required: true, // Required field
                                                    labelPosition: 'top',
                                                    options: [
                                                        {
                                                            id: '20',
                                                            value: _(
                                                                'Apuesta deportiva', // Sports bet option
                                                            ),
                                                        },
                                                        {
                                                            id: '30',
                                                            value: _(
                                                                'Apuesta de casino', // Casino bet option
                                                            ),
                                                        },
                                                    ],
                                                    labelWidth: 150,
                                                },
                                                {
                                                    view: 'text',
                                                    label: _('Id Apuesta:'), // Label for bet ID
                                                    name: 'Identifier',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button', // Cancel button
                                                            value: _('Cancelar'),
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close popup
                                                                $$('subform').setValues(
                                                                    $$('subform').getCleanValues(), // Reset form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button
                                                            type: 'form',
                                                            value: _('Guardar'),
                                                            click: function ($e) {
                                                                var values = $$('subform').getValues(); // Get form values
                                                                if (
                                                                    $$('subform').validate() // Validate form
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Report/loyaltyPoints', // API endpoint
                                                                            values, // Send form values
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var json = JSON.parse(
                                                                                        text, // Parse response
                                                                                    );
                                                                                    if (
                                                                                        json.HasError // Check for errors
                                                                                    ) {
                                                                                        webix.message({
                                                                                            title: _('¡Error!'),
                                                                                            type: 'alert-error',
                                                                                            text: json.AlertMessage, // Display error message
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Puntos Ajustado', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('subform').setValues(
                                                                        $$('subform').getCleanValues(), // Reset form values
                                                                    );
                                                                    this.getTopParentView().hide(); // Close popup
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Completa los campos...', // Validation error message
                                                                        ),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show popup
                            },
                        },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            click: () => {
                                $$('myForm2').clear(); // Clear form
                                $$('Type').setValue(0); // Reset type selection
                                $$('NegativeBalances').setValue(1); // Reset negative balances
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter', // Enter key shortcut
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get filter data
                                this.app.callEvent(
                                    'balanceAdjustments:filter',
                                    [filterdata], // Trigger filter event
                                );
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };
        const filterPopup = webix.ui({
            view: 'window', // Popup window for filters
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Form for filters
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }
}

// FILE DOCUMENTED
